var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackarrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_584_5956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 12.0335C36 13.1462 35.1295 14.0445 34.0569 14.0445H6.02116L12.3195 20.568C13.0787 21.3536 13.0761 22.6272 12.3169 23.4128C11.9387 23.8043 11.4412 24 10.9438 24C10.4463 24 9.9489 23.8043 9.57064 23.4101L0.99489 14.5298C0.352357 13.8648 0 12.98 0 12.0416V12.0308C0.00259086 11.087 0.36013 10.2022 1.00784 9.53993L9.74682 0.584508C10.5111 -0.198421 11.7418 -0.193059 12.4957 0.597914C13.2522 1.38621 13.2445 2.65981 12.4828 3.44005L6.06002 10.0226H34.0569C35.1295 10.0226 36 10.9235 36 12.0335Z",
    fill: "#8F8A86"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_584_5956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackarrow);
export default __webpack_public_path__ + "static/media/backarrow.515c95b8140f737fb2a543fae24f11b6.svg";
export { ForwardRef as ReactComponent };